import {Injectable} from '@angular/core';
import DOMPurify from 'dompurify';
import {ALLOWED_TAGS_ATTRIBUTES} from 'src/app/shared/constants/dompurify-config';

@Injectable({providedIn: 'root'})
export class SanitizeXssService {
  public sanitizeXss<T extends {[key: string]: any}>(data: T, keysToSanitize: string[]): T {
    for (const key of keysToSanitize) {
      if (key in data) {
        data[key as keyof T] = DOMPurify.sanitize(data[key], ALLOWED_TAGS_ATTRIBUTES);
      }
    }

    return data;
  }

  public sanitizeXssContent<T>(data: T): T {
    return DOMPurify.sanitize(data, ALLOWED_TAGS_ATTRIBUTES);
  }
}
